import React from 'react'
import "./css/common.css"


export default function StudyMaterialTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        STUDY MATERIAL
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
